import { useTranslations } from 'next-intl';
import { ModalPortal } from '@/components/layout/modals/ModalPortal';
import { Button } from '@/components/ui/button/Button';
import { PATHS } from '@/constants/path';
import { useRouter } from '@/i18n/routing';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const MigrationNotFoundModal = ({ isOpen, onClose }: Props) => {
  const t = useTranslations();
  const { push } = useRouter();

  const handleClick = () => {
    onClose();
    push(PATHS.ROOT);
  };

  return (
    <ModalPortal
      isOpen={isOpen}
      onClose={onClose}
      cancelable
      title={t('livenode-id-migration-user-not-found_title')}
      body={t('livenode-id-migration-user-not-found_description')}
      PrimaryButtonComponent={() => (
        <Button label={t('common-back_to_top')} fullWidth onClick={handleClick} />
      )}
    />
  );
};
